import { createAction, props } from '@ngrx/store';
import { Transfer } from '@app/shared/models/transfer';

export const loadUserTransfers = createAction(
  '[UserTransfer] Load UserTransfers',
);

export const loadUserTransfersSent = createAction(
  '[UserTransfer] Load UserTransfers Sent',
);

export const loadUserTransfersSentSuccess = createAction(
  '[UserTransfer] Load UserTransfers Sent Success',
  props<{ transfers: Transfer[] }>()
);

export const loadUserTransfersSentFailure = createAction(
  '[UserTransfer] Load UserTransfers Sent Failure',
  props<{ error: string }>()
);

export const loadUserTransfersReceived = createAction(
  '[UserTransfer] Load UserTransfers Received',
);

export const loadUserTransfersReceivedSuccess = createAction(
  '[UserTransfer] Load UserTransfers Received Success',
  props<{ transfers: Transfer[] }>()
);

export const loadUserTransfersReceivedFailure = createAction(
  '[UserTransfer] Load UserTransfers Received Failure',
  props<{ error: string }>()
);

export const setSelectedSection = createAction(
  '[UserTransfer] Set Selected Section',
  props<{ section: string }>()
);

export const loadTransfer = createAction(
  '[UserTransfer] Load Transfer',
  props<{ transferId: string }>()
);

export const loadTransferDetails = createAction(
  '[UserTransfer] Load Transfer Details',
  props<{ transferId: string }>()
);

export const loadTransferDetailsSuccess = createAction(
  '[UserTransfer] Load Transfer Details Success',
  props<{ transfer: Transfer }>()
);

export const loadTransferDetailsFailure = createAction(
  '[UserTransfer] Load Transfer Details Failure',
  props<{ error: string }>()
);

export const loadTransferDetailsFiles = createAction(
  '[UserTransfer] Load Transfer Details Files',
  props<{ transferId: string }>()
);

export const loadTransferDetailsFilesSuccess = createAction(
  '[UserTransfer] Load Transfer Details Files Success',
  props<{ transferFiles: any[] }>()
);

export const loadTransferDetailsFilesFailure = createAction(
  '[UserTransfer] Load Transfer Details Files Failure',
  props<{ error: string }>()
);

export const loadTransferEvents = createAction(
  '[UserTransfer] Load Transfer Events',
  props<{ transferId: string }>()
);

export const loadTransferEventsSuccess = createAction(
  '[UserTransfer] Load Transfer Events Success',
  props<{ events: any[], eventsGroupedByEmailArray: any[], eventsGroupedByAnonymousUserArray: any[] }>()
);

export const loadTransferEventsFailure = createAction(
  '[UserTransfer] Load Transfer Events Failure',
  props<{ error: string }>()
);

export const deleteTransfer = createAction(
  '[UserTransfer] Delete Transfer',
  props<{ transferId: string }>()
);

export const deleteTransferSuccess = createAction(
  '[UserTransfer] Delete Transfer Success',
  props<{ transferId: string }>()
);

export const deleteTransferFailure = createAction(
  '[UserTransfer] Delete Transfer Failure',
  props<{ error: string }>()
);




